var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewPo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M0.666626 23C0.666626 10.2975 10.9641 0 23.6666 0H37.6666C50.3692 0 60.6666 10.2975 60.6666 23V37C60.6666 49.7025 50.3692 60 37.6666 60H23.6666C10.9641 60 0.666626 49.7025 0.666626 37V23Z",
    fill: "#8280FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1666 20H24.1666C22.5098 20 21.1666 21.3431 21.1666 23V41C21.1666 42.6569 22.5098 44 24.1666 44H42.1666C43.8235 44 45.1666 42.6569 45.1666 41V23C45.1666 21.3431 43.8235 20 42.1666 20Z",
    fill: "#5857A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1666 16H20.1666C18.5098 16 17.1666 17.3431 17.1666 19V37C17.1666 38.6569 18.5098 40 20.1666 40H38.1666C39.8235 40 41.1666 38.6569 41.1666 37V19C41.1666 17.3431 39.8235 16 38.1666 16Z",
    fill: "#8280FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1666 27H30.1666V22C30.1666 21.7348 30.0613 21.4804 29.8737 21.2929C29.6862 21.1054 29.4318 21 29.1666 21C28.9014 21 28.6471 21.1054 28.4595 21.2929C28.272 21.4804 28.1666 21.7348 28.1666 22V27H23.1666C22.9014 27 22.6471 27.1054 22.4595 27.2929C22.272 27.4804 22.1666 27.7348 22.1666 28C22.1666 28.2652 22.272 28.5196 22.4595 28.7071C22.6471 28.8946 22.9014 29 23.1666 29H28.1666V34C28.1666 34.2652 28.272 34.5196 28.4595 34.7071C28.6471 34.8946 28.9014 35 29.1666 35C29.4318 35 29.6862 34.8946 29.8737 34.7071C30.0613 34.5196 30.1666 34.2652 30.1666 34V29H35.1666C35.4318 29 35.6862 28.8946 35.8737 28.7071C36.0613 28.5196 36.1666 28.2652 36.1666 28C36.1666 27.7348 36.0613 27.4804 35.8737 27.2929C35.6862 27.1054 35.4318 27 35.1666 27Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPo);
export default __webpack_public_path__ + "static/media/new-po.69c4cf6c83f950cc953c3d5b1c3edfb7.svg";
export { ForwardRef as ReactComponent };